import { useApiClient } from '../../hooks/useApiClient.ts';
import { DisparityType } from '../../types/Disparity/DisparityType.type.ts';

export const useDisparityTypeApi = () => {
  const apiClient = useApiClient();

  return {
    getDisparityTypes: (): Promise<DisparityType[]> => apiClient(`/disparity_types/`),
  };
};
